export const reactions = [
    { title: 'Thank You', url: '/search/thank-you' },
    { title: 'Love', url: '/search/love' },
    { title: 'Funny', url: '/search/funny' },
    { title: 'Yes', url: '/search/yes' },
    { title: 'Excited', url: '/search/excited' },
    { title: 'Kiss', url: '/search/kiss' },
    { title: 'Hello', url: '/search/hello' },
    { title: 'Happy', url: '/search/happy' },
    { title: 'Sad', url: '/search/sad' },
    { title: 'No', url: '/search/no' },
    { title: 'Crying', url: '/search/crying' },
    { title: 'Waiting', url: '/search/waiting' },
    { title: 'Congratulations', url: '/search/congratulations' },
    { title: 'Yay', url: '/search/yay' },
    { title: 'Hug', url: '/search/hug' },
    { title: 'What', url: '/search/what' },
    { title: 'Laughing', url: '/search/laughing' },
    { title: 'Dancing', url: '/search/dancing' },
    { title: 'Confused', url: '/search/confused' },
    { title: 'Wow', url: '/search/wow' },
    { title: 'Celebrate', url: '/search/celebrate' },
    { title: 'Shocked', url: '/search/shocked' },
    { title: 'Thumbs Up', url: '/search/thumbs-up' },
    { title: 'WTF', url: '/search/wtf' },
    { title: 'Tired', url: '/search/tired' },
    { title: 'LOL', url: '/search/lol' },
    { title: 'Nope', url: '/search/nope' },
    { title: 'Bye', url: '/search/bye' },
    { title: 'Angry', url: '/search/angry' },
    { title: 'Welcome', url: '/search/welcome' },
    { title: 'OK', url: '/search/ok' },
    { title: 'Cute', url: '/search/cute' },
    { title: 'Miss You', url: '/search/miss-you' },
    { title: 'Sleepy', url: '/search/sleepy' },
    { title: 'Thinking', url: '/search/thinking' },
    { title: 'Eye Roll', url: '/search/eye-roll' },
    { title: 'Do It', url: '/search/do-it' },
    { title: 'Side Eye', url: '/search/side-eye' },
    { title: 'Crazy', url: '/search/crazy' },
    { title: 'Fire', url: '/search/fire' },
    { title: 'Scared', url: '/search/scared' },
    { title: 'Huh', url: '/search/huh' },
]
